export enum OverlayState {
  None = 'NONE',
  Quote = 'QUOTE',
  CustomerStatus = 'CUSTOMER_STATUS',
  Checkout = 'CHECKOUT',
  Register = 'REGISTER',
}
